module.exports = __webpack_public_path__ + "110efbf8a9a95ec3384b8b45dc5bc607.svg";